import React, { useEffect, useState } from "react";
// import { Navigate, useParams } from "react-router-dom";
import { Route, Routes, Link } from "react-router-dom";
import Axios from "axios";
import moment from "moment";
import { FieldArray, Form, Formik } from "formik";
import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import FormikControl from "../../../Components/LifeInsFormikComponent/FormikControl";
import createInitialValue from "../../../Utilities/InitialValuesSetup/createInitialValue";
import * as Yup from "yup";
import { Box } from "@mui/system";
//import payPremium from "../JSONbodies/Paypremium";
import automaticValidationSchema from "../../../Utilities/ValidationSchemaSetup/automaticValidationSchema";
import { useNavigate, useParams } from "react-router";
import TextField from "@mui/material/TextField";
import AutoFillform from "../../../Utilities/AutoFillsetup/AutoFillsetup";
import finalreq from "../ValidateProposer/FinalReqbody";
import OTP_Dialog from "../../../Components/Modals/OTP_Dialog";
import uuid from "react-uuid";
import CategoryHeader from "../../../Components/Headers/CategoryHeader";
//import { Dialogbox } from "../Modal/Dialog";

//var serialize = require('form-serialize');

function PaypremiumForm(props) {
  const [productDetails, setProductDetails] = useState([]);
  /*  const [open, setOpen] = React.useState(false);
  const [verifyOTP,setVerifyOTP]=useState(false) */
  const [savedValisate, setSavedValidate] = useState({});
  const [transferData, setTransferData] = useState({});

  const [open, setOpen] = React.useState(false);
  const [verifyOTP, setVerifyOTP] = useState(false);
  const [OTPSuccessful, setOTPSuccessful] = useState(false);
  const [responseGetOTP, setResponseGetOTP] = useState();
  const [UserID, setuid] = useState();
  const [ApplicationNo, setAppno] = useState();
  const [OTP, setOTP] = useState(false);
  const [initial, setInitial] = useState({
    mobileNumber: "",
    UserID: ""
  });

  const { id } = useParams();

  const navigate = useNavigate();

  const productIdArray = id.split("*");
  const productRef = productIdArray[0];
  const transId = productIdArray[1];
  const validateFormid = productIdArray[2];

  var initialValues = {};
  var finalIni = {};
  if (Object.keys(productDetails).length > 0) {
    initialValues = createInitialValue(productDetails);

    initialValues = AutoFillform(savedValisate, initialValues);
    console.log(initialValues, "initialvalues");
    console.log("initial for dialog",initial);
    // finalIni=initialValues
    // Object.entries(finalIni).map((field, ind) => {
    //   Object.entries(transferData).map((trans, transInd) => {
    //     if (field[0] === trans[0]) {
    //       console.log('sdd',field[0],trans[1])
    //       //field[0]=trans[1]
    //        finalIni={...finalIni,[`${field[0]}`]:`${trans[1]}`}
    //     }
    //   })

    // })
    // Object.entries(finalIni).map((field, ind) => {
    //   if(field[0]==="PayableAmount"){
    //     //console.log('total prem',transferData.TotalPremium)
    //     finalIni={...finalIni,[`${field[0]}`]:`${transferData.TotalPremium}`}
    //   }
    //   if(field[0]==="CustomerName"){
    //     finalIni={...finalIni,[`${field[0]}`]:`${transferData.LAName}`}
    //   }
    //   if(field[0]==="MobileNumber"){
    //     finalIni={...finalIni,[`${field[0]}`]:`${transferData.MobileNo}`}
    //   }
    // })

    /*  Object.entries(initialValues).map((field,ind)=>{
      if (!transferData.hasOwnProperty(field[0])) {
        finalIni[`${field[0]}`] = field[1];
      }
    })
    finalIni={...finalIni,...transferData} */
  }

  var validationSchema = Yup.object().shape({});
  if (Object.keys(productDetails).length > 0) {
    validationSchema = automaticValidationSchema(
      productDetails.requestBody.formFields.fields
    );
  }
  console.log(transferData, "transData in payPremium");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setInitial({ mobileNumber: "" });
    setOTP(false);
    setVerifyOTP(false);
    setOpen(false);
  };

  useEffect(() => {
    setAppno(uuid().split("-").join("").toUpperCase().slice(0, 15));
    let domainExpress = "";
    let domainDjango = "";

    if (window.location.hostname === "localhost") {
      domainExpress = process.env.REACT_APP_LOCAL_EXPRESS;
      domainDjango = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domainExpress = process.env.REACT_APP_PRODUCTION_EXPRESS;
      domainDjango = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domainExpress = process.env.REACT_APP_UAT_EXPRESS;
      domainDjango = process.env.REACT_APP_UAT_DJANGO;
    }

    Axios.get(
      `${domainExpress}/api/v1/lifeInsurance/validate-form/${productRef}`
      //`http://localhost:3002/api/v1/lifeInsurance/validate-form/${productRef}`
    ).then((response) => {
      if (response.status === 200) {
        console.log("response from node", response);
        setProductDetails(response.data);
      }
    });

    Axios.get(
      `${domainDjango}/api/shriram/plp-validate-response/${transId}/`
    ).then((response) => {
      setTransferData(response.data);
      console.log("trans of pay premium", response);
    });

    Axios.get(
      `${domainDjango}/api/life-insurance/get-validate-proposal/${validateFormid}/`
    ).then((response) => {
      // setTransferData(response.data)
      console.log(response, "Savedvalidate ");
      setSavedValidate(response.data);
      setInitial({...initial,UserID:response.data.UserID});
      
    });
  }, []);

  const onSubmit = (values) => {
    console.log("Form submit pay premium", JSON.stringify(values));

    if (!verifyOTP && !OTPSuccessful) {
      handleClickOpen();
    } else {
      navigate(`/life-insurance/payment-options/${transId}*${validateFormid}`, {
        state: { values },
      });
    }

    /*  if (window.location.hostname === 'localhost') {
      Axios.post(" http://127.0.0.1:8000/api/life-insurance/pay-premium/",JSON.stringify(values)).then(response=>{
        console.log(response,"response in pay premium")
        if(response.data.ResultSet.ResponseCode ==='200'){
          //window.open(`http://${response.data.ResultSet.Response.PaymentUrl}`)
          navigate(`/life-insurance/payment-status/:${response.data.ResultSet.TxnRef }`,
          //{state :{savedValisate}
          )
        }
       })
    }else{
      Axios.post(" http://65.0.70.70:8000/api/life-insurance/pay-premium/",JSON.stringify(values)).then(response=>{
        console.log(response,"response in pay premium")
        if(response.data.ResultSet.ResponseCode ==='200'){
          window.open(`http://${response.data.ResultSet.Response.PaymentUrl}`)
        }
       })
    } */

    // navigate("/life-insurance/submitproposal");
  };


  const backButtonHandler = () => {
    navigate(-1);
}

  return (
    <div id="">
      <div className="">
        <CategoryHeader title="Life Insurance" />

        <h3 className="fw-400 text-center my-4 heading-text">
          Pay premium Form
        </h3>
        {Object.keys(initialValues).length > 0 ? (
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => {
              console.log("formik val", formik);
              return (
                <div className="justify-content-center ">
                  <Form>
                    <div className="bg-white shadow-md rounded-card  pt-sm-4 pb-sm-5 px-sm-5 form-container ">
                      {Object.keys(productDetails).length > 0
                        ? productDetails.requestBody.formFields.fields.map(
                            (field, index) => {
                              return field.htmlElement === "TextField" ? (
                                <div
                                  className="mb-3"
                                  key={index}
                                  hidden={field.hidden}
                                >
                                  <FormikControl
                                    control="input"
                                    errors={formik.errors}
                                    name={field.name}
                                    readOnly={field.readOnly}
                                    url={field.url}
                                    label={field.label}
                                    type={field.dataType}
                                    touched={formik.touched}
                                  />
                                </div>
                              ) : field.htmlElement === "Select" ? (
                                <div
                                  className="mb-3"
                                  key={index}
                                  hidden={field.hidden}
                                >
                                  <FormikControl
                                    control="select"
                                    name={field.name}
                                    errors={formik.errors}
                                    readOnly={field.readOnly}
                                    url={field.url}
                                    label={field.label}
                                    type={field.dataType}
                                    options={field.options}
                                    touched={formik.touched}
                                  />
                                </div>
                              ) : field.htmlElement === "Radio" ? (
                                <div
                                  className="mb-3"
                                  key={index}
                                  hidden={field.hidden}
                                >
                                  <FormikControl
                                    control="radio"
                                    name={field.name}
                                    errors={formik.errors}
                                    readOnly={field.readOnly}
                                    url={field.url}
                                    label={field.label}
                                    type={field.dataType}
                                    options={field.options}
                                    touched={formik.touched}
                                  />
                                </div>
                              ) : null;
                            }
                          )
                        : null}
                    </div>
                    <div className="btn-sec position-fixed bottom-0 mt-3 ">
                      
                      <button
                        className="Goback_btn"
                        onClick={backButtonHandler}
                      >
                        Back
                      </button>
                      <button
                        className="submitBtn "
                        type="submit"
                        //disabled={formik.isSubmitting}
                      >
                        Submit
                      </button>
                    </div>
                  </Form>
                </div>
              );
            }}
          </Formik>
        ) : (
          <Typography>Loading....</Typography>
        )}

        <OTP_Dialog
          OTPSuccessful={OTPSuccessful}
          setOTPSuccessful={setOTPSuccessful}
          setResponseGetOTP={setResponseGetOTP}
          responseGetOTP={responseGetOTP}
          ApplicationNo={ApplicationNo}
          OTP={OTP}
          setOTP={setOTP}
          open={open}
          onClose={handleClose}
          initial={initial}
          setInitial={setInitial}
        />
      </div>
    </div>
  );
}

export default PaypremiumForm;
